import { Link } from 'react-router-dom';
import './BrandLogo.css';

/** Shared brand identity across public and signed-in pages. */
export function BrandLogo({ to = '/' }: { to?: string }) {
    return (
        <Link to={to} className="brand-logo" aria-label="ParentsCheck">
            <img src="/images/parentscheck-mark.svg" width="40" height="40" alt="" aria-hidden="true" />
            <span className="brand-logo-wordmark" aria-hidden="true">Parents<span>Check</span></span>
        </Link>
    );
}
